export default "__VITE_ASSET__42b8920d__"